module.exports = "<h4 class=\"loading\">Loading...</h4>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/bcm-login/bcm-login.component.html
// module id = ../../../../../src/app/bcm-login/bcm-login.component.html
// module chunks = main